import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BoxPage() {

  document.title = `Series III Box Set in Neon Yellow | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Limited to 250 hand-numbered copies, this gold-embossed slipcase features all six Series III volumes of five new titles along with an expanded reissue of Bob Flanagan's Fuck Journal from the original Hanuman Books. Boxes come in four colors: Neon Yellow, Rose, Mid Green, Purple.`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={[
            '../../Boxsets/Boxset_Series_III_Multiview_Neon.png',
            '../../Boxsets/Boxset_Series_III_Spines_Neon.png',
            '../../Boxsets/Boxset_Series_III_Neon.png',
          ]} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Series III Box Set</h1>
            <div className='productAuthor'>Limited Edition</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'hanuman_box_03_ny'} />
            <div className='productPrice'>$119.99 USD</div>
          </div>

          <div className='productDescription'> Limited to 250 hand-numbered copies, this gold-embossed slipcase features all six Series III volumes of five new titles along with an expanded reissue of Bob Flanagan's <em>Fuck Journal</em> from the original Hanuman Books. Boxes come in four colors: Neon Yellow, Rose, Mid Green, Purple.
          </div>
          <div className='productDescription'>This box is <strong>Neon Yellow</strong> | Other Variants: <Link to='/limited/series-three-box-set-mid-green'>Mid Green</Link>, <Link to='/limited/series-three-box-set-rose'>Rose</Link>, <Link to='/limited/series-three-box-set-purple'>Purple</Link>.
          </div>
          <div className='productDescription'>
            <p>
              <em>While the titles will remain individually available, this box set will never be reproduced.</em>
            </p>
            <p>Featured Titles:</p>
            <ul>
              <li><em>Space Opera</em> by Georgi Gospodinov, trans. Angela Rodel</li>
              <li><em>Mishima's Head</em> by Mario Bellatin, trans. Shook</li>
              <li><em>Love Never Dies</em> by Eka Kurniawan, trans. Annie Tucker</li>
              <li><em>Kafka & I</em> by Can Xue, trans. Deanna Ren</li>
              <li><em>The History of the Dolls and What They Did</em> by Jesse Ball</li>
              <li><em>Fuck Journal</em> by Bob Flanagan</li>

            </ul>
          </div>
          <div className='productMetadata'>
            <div>Series III</div>
            <div>Summer 2025</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}